import React, { MouseEventHandler, PropsWithChildren } from "react";
import cx from "classnames";

interface Props {
  onClick?: MouseEventHandler<HTMLButtonElement> | undefined;
  className?: string;
  isText?: boolean;
  colorEnabled?: boolean;
}

const ProfileButton = ({
  onClick,
  className,
  isText,
  children,
  colorEnabled = true,
}: PropsWithChildren<Props>) => {
  const classes = cx(
    "flex items-center gap-2 h-10 w-10 justify-center rounded-[10px]",
    "text-sm uppercase tracking-wide transition",
    {
      "h-auto w-auto px-4 py-2.5": isText,
      "bg-white/15 hover:bg-white/20 border-[0.5px] border-white/15 shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-4px_rgba(0,0,0,0.1)]":
        colorEnabled,
    },
    className
  );

  return (
    <button onClick={onClick} className={classes}>
      {children}
    </button>
  );
};

export default ProfileButton;
